import React, { useEffect, useState } from 'react';
import { Button, Drawer, Spin, Popconfirm } from 'antd';
import { message } from './../../utils/Utils';
import { PlusOutlined, SearchOutlined, StarOutlined, StarFilled, EyeOutlined, FormOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import styles from './viewCombos.module.scss';
import DrawerNewCombo from '../../dashboard/combosTable/drawerNewCombo/DrawerNewCombo';
import apiConnect from '../../../config/apiConfig';
import ComboInfo from '../comboInfo/ComboInfo';
import { useHistory } from 'react-router';

const ViewCombos = ({setProductsForComboEdit}) => {
  // const {
  //   actions,
  //   container,
  //   title,
  //   titleSpan,
  //   containerInput,
  //   inpSearch,
  //   btnSearch,
  //   iconSearch,
  //   btnAdd,
  //   combosContainer,
  //   comboLayout,
  //   iconStarred,
  //   comboName,
  //   articles,
  //   iconOutlined,
  //   iconDelete,
  //   btn,
  //   btnView,
  //   btnDelete,
  //   btnEdit
  // } = styles;

  const userId = localStorage.getItem('id');
  const antIcon = <LoadingOutlined styles={{ fontSize: 24 }} spin />;
  const [comboData, setComboData] = useState({});
  const [detailVisible, setDetailVisible] = useState(false);
  const [addVisible, setAddVisible] = useState(false);
  const [combos, setCombos] = useState([]);
  const [tableCombos, setTableCombos] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState({});
  const [visible, setVisible] = useState({});
  const history = useHistory();
  const maxStarredCombos = 6;
  const [starredQuantity, setStarredQuantity] = useState(0);


  useEffect(() => {
    getCombos();
    handleSearch('');
  }, []);

  const getCombos = async () => {
    try {
      const { data } = await apiConnect.get(`/users/${userId}/combos`);
      const starredCombosQuantity = data.data.filter((combo) => combo.starred).length;
      setCombos(data.data);
      setTableCombos(data.data);
      setStarredQuantity(starredCombosQuantity);
    } catch(error) {
      console.log(error); //eslint-disable-line
    }
  };

  const handleOpenAddDrawer = () => {
    setAddVisible(!addVisible);
  };

  const handleOpenDetailDrawer = (combo) => {
    if(combo) setComboData(combo);
    setDetailVisible(!detailVisible);
  };


  const handleSearch = value => {
    const res = combos.filter(element => {
      if(element.name.toString().toLowerCase().includes(value.toLowerCase())) return element;
    });
    setTableCombos(res);
  };

  const handleChange = e => {
    setSearch(e.target.value);
    handleSearch(e.target.value);
  };

  async function deleteCombo(id) {
    try {
      setLoadingDelete({...loadingDelete, [id]: true});
      try {
        await apiConnect.delete(`/combos/${id}`);
      } catch (error) {
        message.error(
          error.response.data.status === 'Stand with orders cannot be deleted'
            ? 'No se puede borrar un combo con compras'
            : 'No se ha podido borrar el combo',
        );
      }
      setVisible({ ...visible, [id]: false });
      getCombos();
      setLoadingDelete({ ...loadingDelete, [id]: false });
    } catch(error) {
      console.log(error) // eslint-disable-line
    }
  }

  const handleEditAction = (combo) => {
    const name = combo.name;
    const standID = combo.stand;
    const description = combo.description;
    const quantity = combo.totalItemsQuantity;
    const type = combo.closedCombo? 'cerrado' : 'abierto';
    const paymentDeadline = combo.paymentDeadline;
    setProductsForComboEdit(combo.products);
    history.push(`/provider/mis-combos/new-combo?paymentDeadline=${paymentDeadline}&id=${combo._id}&name=${name}&stand=${standID}&description=${description}&comboQuantity=${quantity}&comboType=${type}&action=edit`);
  };

  const handleStarredToggle = async (combo) => {
    if(!combo.starred && starredQuantity >= maxStarredCombos){
      alert('Solo puede seleccionar 6 combos');
      return;
    }

    try {
      setLoading({...loading, [combo._id]: true});
      await apiConnect.put(`/combos/${combo._id}`, { starred: !combo.starred });
      await getCombos();
      setLoading({...loading, [combo._id]: false});
    }
    catch(error) {
      console.log(error); // eslint-disable-line
    }
  };

  return (
    <div className={styles.container}>
      
      <h3 className={styles.title}>
        Mis Combos
        <span className={styles.titleSpan}>({combos.length})</span>
      </h3>
      <div className={styles.containerInput}>
        <input
          className={styles.inpSearch}
          placeholder='buscar...'
          onChange={(e)=> handleChange(e)}
          value={search}
        />
        <Button
          className={styles.btnSearch}
        >
          <SearchOutlined className={styles.iconSearch}/>
        </Button>
      </div>
      <Button
        className={styles.btnAdd}
        onClick={() => handleOpenAddDrawer()}
      >
        <PlusOutlined/>
        AGREGAR
      </Button>
      <Drawer
        placement="right"
        closable={true}
        onClose={()=> handleOpenAddDrawer()}
        visible={addVisible}
        mask={false}
        width={1000}
      >
        <DrawerNewCombo
          combos={combos}
        />
      </Drawer>

      <Drawer
        placement="right"
        closable={true}
        onClose={()=> handleOpenDetailDrawer()}
        visible={detailVisible}
        mask={false}
        width={474}
      >
        <ComboInfo combo={comboData}/>
      </Drawer>

      <div className={styles.combosContainer}>
        {tableCombos.map(combo => {
          return(
            <div className={styles.comboLayout} key={combo._id}>
              {combo.starred
                ? (loading[combo._id] && <Spin indicator={antIcon} className={styles.iconStarred}/>) || <StarFilled className={styles.iconStarred} onClick={() => handleStarredToggle(combo)}/>
                : (loading[combo._id] && <Spin indicator={antIcon} className={styles.iconStarred}/>) || <StarOutlined className={styles.iconStarred} onClick={() => handleStarredToggle(combo)}/>
              }
              <h4 className={styles.comboName}>Combo {combo.name}</h4>
              <h4 className={styles.articles}>({combo.products.length} articulos)</h4>
              <div className={styles.actions}>
                <Button
                  className={`${styles.btn} ${styles.btnView}`}
                  onClick={()=> handleOpenDetailDrawer(combo)}
                >
                  <EyeOutlined className={styles.iconOutlined}/>
                </Button>
                <Button onClick={() => handleEditAction(combo)} className={`${styles.btn} ${styles.btnEdit}`}>
                  <FormOutlined className={styles.iconOutlined}/>
                </Button>
                <Popconfirm
                  title="¿Estás seguro de eliminar este combo?"
                  onConfirm={() => deleteCombo(combo._id)}
                  onCancel={() => setVisible({...visible, [combo._id]: false})}
                  visible={visible[combo._id]}
                  okButtonProps={{ loading: loadingDelete[combo._id] }}
                  okText="Si"
                  cancelText="No"
                >
                  <Button className={`${styles.btn} ${styles.btnDelete}`} onClick={() => setVisible({ ...visible, [combo._id]: true })}>
                    <DeleteOutlined className={`${styles.iconOutlined} ${styles.iconDelete}`}/>
                  </Button>
                </Popconfirm>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ViewCombos;